import { render, staticRenderFns } from "./IconTypeVideo.vue?vue&type=template&id=eb61e996&scoped=true"
import script from "./IconTypeVideo.vue?vue&type=script&lang=js"
export * from "./IconTypeVideo.vue?vue&type=script&lang=js"
import style0 from "./IconTypeVideo.vue?vue&type=style&index=0&id=eb61e996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb61e996",
  null
  
)

export default component.exports